import React from 'react';
import { Box, Typography } from '@mui/material';
import appTheme from '../theme/appTheme.json';
import { milesToKilometers } from '../../../utils/DistanceUtils';
import { isNil } from 'lodash';
import styled from 'styled-components';
import StyledProps from '../theme/AppThemeInterface';
import { EMPTY_FIELD_STRING_PLACEHOLDER } from '../../../utils/StringUtils';
import { secondsToFormattedHoursMinutesSecondsColonDelimitedFormat } from '../../../utils/DateTimeUtils';
import { LegInfo } from '../map_overlays/RulerToolDistanceSummary';

export const LAT_LNG_DECIMAL_PLACES = 4;

export interface RulerLegOverlayComponentProps {
  legData: LegInfo[];
  legIndex: number;
  latLng: google.maps.LatLng;
  showAircraftETA: boolean;
}

const RulerLegOverlayComponent: React.FC<RulerLegOverlayComponentProps> = (props: RulerLegOverlayComponentProps) => {
  const { legData, legIndex, latLng, showAircraftETA } = props;

  // Create the strings for the distance, heading, and ETA
  const distanceString = !isNil(legData[legIndex]?.legDistanceMiles)
    ? `${legData[legIndex].legDistanceMiles.toFixed(1)} mi (${milesToKilometers(
        legData[legIndex].legDistanceMiles,
        1,
      )} km)`
    : EMPTY_FIELD_STRING_PLACEHOLDER;
  const etaString =
    legData[legIndex]?.legETASeconds > 0
      ? secondsToFormattedHoursMinutesSecondsColonDelimitedFormat(legData[legIndex].legETASeconds)
      : EMPTY_FIELD_STRING_PLACEHOLDER;

  // Return the overlay component
  return (
    <Box
      sx={{
        backgroundColor: appTheme.mptPrimaryBackgroundColor,
        padding: '8px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box>
        <TitleTypography>Distance: </TitleTypography>
        <ContentTypography>{distanceString}</ContentTypography>
      </Box>
      <Box>
        <TitleTypography>Latitude: </TitleTypography>
        <ContentTypography>{latLng.lat().toFixed(LAT_LNG_DECIMAL_PLACES)}</ContentTypography>
      </Box>
      <Box>
        <TitleTypography>Longitude: </TitleTypography>
        <ContentTypography>{latLng.lng().toFixed(LAT_LNG_DECIMAL_PLACES)}</ContentTypography>
      </Box>
      {showAircraftETA ? (
        <Box>
          <TitleTypography>ETA: </TitleTypography>
          <ContentTypography>{etaString}</ContentTypography>
        </Box>
      ) : null}
    </Box>
  );
};

export default RulerLegOverlayComponent;

export const TitleTypography = styled(Typography)`
  font: ${({ theme }: StyledProps) => theme.appFontFamily};
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  display: inline;
`;
export const ContentTypography = styled(Typography)`
  font: ${({ theme }: StyledProps) => theme.appFontFamily};
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  display: inline;
`;
